<nav [attr.aria-label]="'nav.main.label' | translate" [ngClass]="{'menu-collapsed': !isMenuExpanded, 'route-triggered': routeTriggered, 'keyboard-triggered': keyboardTriggered, 'in-focus': isInFocus}" (mouseleave)="menuMouseLeave()">
  <header>
    <button type="button"
       class="toggle-menu-collapse"
       [attr.aria-label]="'nav.sidebar.toggle' | translate"
       [attr.aria-expanded]="isMenuExpanded"
       (click)="toggleMenuCollapse()"
       (keyup)="$event.stopPropagation()">
      <i class="icon icon-sidebar_toggle"></i>
    </button>
  </header>
  <div class="menu-items">
    <ul *ngIf="inputMenuItems" role="tree" name="menu" accesskey="w" tabindex="{{tabIndex}}" [attr.aria-activedescendant]="ariaActiveDescendant" (focus)="onFocus()" (focusout)="onFocusOut()">
    <li *ngFor="let menuItem of inputMenuItems"
      role="treeitem"
      [id]="menuItem.id"
      aria-level="1"
      [attr.aria-selected]="(menuItem == focusedItem && focusedSubItem==null)"
      [attr.aria-expanded]="!menuItem.subItems ? null : menuItem.expanded ? true : false"
      [ngClass]="{'menu-item-selected': (menuItem == focusedItem && focusedSubItem==null)}">
      <a title="{{menuItem.key | translate}}"
        class="menu-item"
        (click)="handleMenuEvent(menuItem, $event)"
        tabindex="-1"
        [ngClass]="{'active-item': menuItem == activeItem}">
        <i class="menu-item-icon" *ngIf="menuItem.icon" [ngClass]="menuItem.icon"></i>
        <span class="menu-item-title">{{menuItem.key | translate}}</span>
        <svg *ngIf="menuItem.subItems" class="menu-item-expand" [ngClass]="{'expanded': menuItem.expanded}" viewBox="0 0 20 20" focusable="false">
            <path d="M8.79,15,.3,6.49A1,1,0,0,1,1.76,5l8,8,8.5-8A1,1,0,1,1,19.7,6.49l-9,8.49a1.68,1.68,0,0,1-.94.26A1.65,1.65,0,0,1,8.79,15Z" />
        </svg>
      </a>
      <ul class="sub-menu" *ngIf="menuItem.subItems" [ngClass]="{'expanded': menuItem.expanded}" role="group">
        <li *ngFor="let subItem of menuItem.subItems"
          role="treeitem"
          [id]="subItem.id"
          aria-level="2"
          [attr.aria-selected]="(subItem == focusedSubItem)"
          [ngClass]="{'menu-item-selected': (subItem == focusedSubItem)}">
          <a title="{{subItem.key | translate}}" class="sub-menu-item"
            (click)="handleSubMenuEvent(menuItem, subItem, $event)"
            tabindex="-1"
            [ngClass]="{'active-sub-item': subItem == activeSubItem}">
            <span>{{subItem.key | translate}}</span>
          </a>
        </li>
      </ul>
    </li>
    </ul>
  </div>
</nav>
